import { Component, inject, Input, OnInit } from '@angular/core';
import { IProduct } from '../../../../../IProduct';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../../manager/edro-network-manager';
import { DisplayRubriqueStatusComponent } from '../../../../../../../../components/ecosystems/display-rubrique-status/display-rubrique-status.component';
import { DisplayRubriqueStatusOnOffComponent } from '../../../../../../../../components/ecosystems/display-rubrique-status-on-off/display-rubrique-status-on-off.component';
import { DisplayRubriqueStatusWithWarningComponent } from '../../../../../../../../components/ecosystems/display-rubrique-status-with-warning/display-rubrique-status-with-warning.component';
import { DisplayRubriqueStatusWithWarningAndCtaComponent } from '../../../../../../../../components/ecosystems/display-rubrique-status-with-warning-and-cta/display-rubrique-status-with-warning-and-cta.component';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { CollapseComponent } from '../../../../../../../../components/ecosystems/collapse/collapse.component';
import {
  brandOverride,
  getPoolMasterClass,
  isSupportTechnique,
} from '../../../../../../ECoSystemsHelper';
import { P00039 } from '../../../../P00039';
import { P00076 } from '../../../../P00076';
import { transformHourToDayHour } from '../../../../../../helper/horloge';
import { P00039DataRxTxIndex } from '../../../../P00039Sync';

@Component({
  selector: 'app-p00076-constance-statut',
  templateUrl: './p00076-constance-statut.component.html',
  styleUrls: ['./p00076-constance-statut.component.scss'],
  standalone: true,
  imports: [
    DisplayRubriqueStatusComponent,
    DisplayRubriqueStatusOnOffComponent,
    DisplayRubriqueStatusWithWarningComponent,
    DisplayRubriqueStatusWithWarningAndCtaComponent,
    TranslatePipe,
    CollapseComponent,
  ],
})
export class P00076ConstanceStatutComponent implements OnInit {
  @Input() productClass: IProduct | null = null;

  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);
  private translateService: TranslateService = inject(TranslateService);

  public actionStack: DeviceActionStackService | null = null;

  constructor() {}

  async ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      null,
    );
  }

  getValue(key: string): number {
    return this.actionStack!.getValue(key);
  }

  transformHourToDayHourLocal(value: number): string {
    return transformHourToDayHour(value, this.translateService);
  }

  get presenceProduit(): number {
    return new P00039().hasProduct(
      this.edroNetworkManager.getPoolContext()!.pool!,
      this.productClass!,
    );
  }

  get hasAlarm(): boolean {
    return this.getValue('coSAlarme') === 1;
  }

  get regulationHasWarning(): boolean {
    return (
      this.getValue('coSAlarmTempsRemplissageMaximum') === 1 ||
      this.getValue('coSAlarmTempsVidangeMaximum') === 1 ||
      this.getValue('coSAlarmNiveauMax') === 1 ||
      this.getValue('coSAlarmNiveauMin') === 1
    );
  }

  get capteurHasWarning(): boolean {
    return (
      this.getValue('coSAlarmBatterieCapteur') === 1 ||
      this.getValue('coSAlarmSignalCapteur') === 1
    );
  }

  getVanneRemplissageValue(): string {
    return this.getValue('coSStatutVanneRemplissage') === 0
      ? this.translateService.instant('P00076.status.regulation.fermee')
      : this.translateService.instant('P00076.status.regulation.ouvert');
  }

  getVanneVidangeValue(): string {
    return this.getValue('coSStatutVanneVidange') === 0
      ? this.translateService.instant('P00076.status.regulation.fermee')
      : this.translateService.instant('P00076.status.regulation.ouvert');
  }

  convertSecondsToTime(seconds: number, displayZero: boolean = false): string {
    if (seconds === 0 && !displayZero) return '00:00:00';

    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;

    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
  }

  getRemplissageDureeValue(): string {
    return this.convertSecondsToTime(
      this.getValue('coSDureeContinueOuvertureVanneRemplissage'),
      true,
    );
  }

  getVidangeDureeValue(): string {
    return this.convertSecondsToTime(
      this.getValue('coSDureeContinueOuvertureVanneVidange'),
      true,
    );
  }

  getTestModeValue(): string {
    return this.getValue('coSModeTest') === 1
      ? this.translateService.instant(
          'P00080.status.general.detectiondebit.yes',
        )
      : this.translateService.instant(
          'P00080.status.general.detectiondebit.no',
        );
  }

  getVolumeRempliValue(): string {
    return (this.getValue('coSVolumeEauRempli') / 100).toFixed(0) + 'm³';
  }

  getVolumeVideValue(): string {
    return (this.getValue('coSVolumeEauVidange') / 100).toFixed(0) + 'm³';
  }

  onResetRemplissage(): void {
    this.actionStack?.editValue(
      P00039DataRxTxIndex.Constance_Control,
      'coCResetManuelDureeRemplissage',
      1,
    );
    this.actionStack?.commit();
  }

  onResetVidange(): void {
    this.actionStack?.editValue(
      P00039DataRxTxIndex.Constance_Control,
      'coCResetManuelDureeVidange',
      1,
    );
    this.actionStack?.commit();
  }

  protected readonly isSupportTechnique = isSupportTechnique;
  protected readonly brandOverride = brandOverride;
}
